import * as types from '../../api/types';
import SessionStorage from '../../api/session-storage';

const admin = SessionStorage.getAdmin() || {};
const user = SessionStorage.getUser() || {};
const room = SessionStorage.getRoom() || '';
const isLogged = SessionStorage.getLoggedUser() || '';
const hasUserLoggedOut = SessionStorage.getUserLoggedOut() || '';

const initialState = {
  admin: {
    reg_id: admin.reg_id || '',
    admin_id: admin.admin_id || '',
    ts_and_cs_ind: admin.ts_and_cs_ind || false,
    token: admin.token || '',
  },
  user: user,
  room: room || '',
  isLogged: isLogged || false,
  hasUserLoggedOut: hasUserLoggedOut || false,
  program: null,
  launchedRemoteProctoring: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.RECEIVED_ADMIN:
      return {
        ...state,
        admin: action.admin,
      };
    case types.RECEIVED_LOG_USER_IN:
      return {
        ...state,
        isLogged: action.isLogged,
      };
    case types.RECEIVED_USER_INFO:
      return {
        ...state,
        user: action.userInfo,
      };
    case types.RECEIVED_ROOM:
      return {
        ...state,
        room: action.room,
      };
    case types.UPDATE_CONFIRMATION_IND:
      return {
        ...state,
        updatedConfirmationInd: action.payload,
      };
    case types.LAUNCH_REMOTE_PROCTORING:
      return {
        ...state,
        launchedRemoteProctoring: action.payload,
      };
    case types.RECEIVED_LOGOUT:
      return {
        ...state,
        hasUserLoggedOut: action.hasUserLoggedOut,
      };
    default:
      return state;
  }
}
